import * as service from './service'
export default {
  namespace: 'recommendUserHome',
  state: {
    demoData: {}
  },
  effects: {},
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
